.description {
  line-height: 2.2rem;
  margin-bottom: 3.2rem;
}

.server-error-message {
  display: flex;
  justify-content: start;
  margin-top: -3rem;
  margin-bottom: 2rem;
  max-width: 100%;

  & > div {
    max-width: 32rem;
  }
}

.input-container {
  &:not(:first-child) {
    margin-top: 1.6rem;
  }
}
